export default __webpack_public_path__ + "static/media/trashcan-blue.8fcf8548.svg";